// extracted by mini-css-extract-plugin
export default {"howItWorksItem":"HowItWorksItem_howItWorksItem__-Jm5f","howItWorksItem__arrow":"HowItWorksItem_howItWorksItem__arrow__7fqBF"};